<template>
  <div class="company-info-page">
    <!-- 基本资料 -->
    <a-card title="企业信息" :bordered="false">
      <a-spin :spinning="spinning">
        <div class="base-info">
          <div class="info-line">
            <span class="label">企业名称：</span>{{ companyInfo.companyName }}
          </div>
          <div class="info-line">
            <span class="label">统一社会信用代码：</span
            >{{ companyInfo.unifySocialCreditCodes }}
          </div>
        </div>
      </a-spin>
    </a-card>

    <!-- 账号设置 -->
    <a-card title="账号设置" style="margin-top: 24px" :bordered="false">
      <div class="setting-item">
        <!-- 状态点+说明 -->
        <div class="left">
          <span :class="['status-dot', 'blue']"></span>
          <span class="main-text"> 企业认证 </span>
          <span class="sub-text">以企业身份参与项目</span>
        </div>

        <!-- 右侧公司名或时间 -->
        <div class="center">
          <template v-if="!spinning">
            {{ companyInfo.companyName }}
          </template>
          <a-spin v-else />
        </div>
        <!-- 操作按钮 -->
        <div class="right"></div>
      </div>

      <div class="setting-item">
        <!-- 状态点+说明 -->
        <div class="left">
          <template
            v-if="
              verifyTimeStatus(companyInfo.operatingPeriodEndDate) == 'normal'
            "
          >
            <span :class="['status-dot', 'blue']"></span>
            <span class="main-text">证件有效</span>
          </template>

          <template
            v-if="
              verifyTimeStatus(companyInfo.operatingPeriodEndDate) == 'near'
            "
          >
            <span :class="['status-dot', 'orange']"></span>
            <span class="main-text">证件即将过期</span>
          </template>

          <template
            v-if="
              verifyTimeStatus(companyInfo.operatingPeriodEndDate) == 'expired'
            "
          >
            <span :class="['status-dot', 'red']"></span>
            <span class="main-text">证件已过期</span>
          </template>

          <template
            v-if="
              verifyTimeStatus(companyInfo.operatingPeriodEndDate) == 'invalid'
            "
          >
            <span :class="['status-dot', 'gray']"></span>
            <span class="main-text">未知证件</span>
          </template>

          <span class="sub-text">证件有效的截止日期</span>
        </div>

        <!-- 右侧公司名或时间 -->
        <div class="center">
          <template v-if="!spinning"
            >{{ companyInfo.operatingPeriodEndDate }}
          </template>
          <a-spin v-else />
        </div>

        <!-- 操作按钮 -->
        <div class="right">
          <a-button type="primary" size="small" @click="changeToBusinessLicense"
            >更新</a-button
          >
        </div>
      </div>

      <div class="setting-item">
        <!-- 状态点+说明 -->
        <div class="left">
          <template
            v-if="
              verifyTimeStatus(companyInfo.authorizationExpirationDate) ==
              'normal'
            "
          >
            <span :class="['status-dot', 'blue']"></span>
            <span class="main-text">授权有效</span>
          </template>

          <template
            v-if="
              verifyTimeStatus(companyInfo.authorizationExpirationDate) ==
              'near'
            "
          >
            <span :class="['status-dot', 'orange']"></span>
            <span class="main-text">授权即将过期</span>
          </template>

          <template
            v-if="
              verifyTimeStatus(companyInfo.authorizationExpirationDate) ==
              'expired'
            "
          >
            <span :class="['status-dot', 'red']"></span>
            <span class="main-text">授权已过期</span>
          </template>

          <template
            v-if="
              verifyTimeStatus(companyInfo.authorizationExpirationDate) ==
              'invalid'
            "
          >
            <span :class="['status-dot', 'gray']"></span>
            <span class="main-text">未知授权</span>
          </template>
          <span class="sub-text">授权有效的截止日期</span>
        </div>

        <!-- 右侧公司名或时间 -->
        <div class="center">
          <template v-if="!spinning"
            >{{ companyInfo.authorizationExpirationDate }}
          </template>
          <a-spin v-else />
        </div>

        <!-- 操作按钮 -->
        <div class="right">
          <a-button
            type="primary"
            size="small"
            @click="changeToAuthorizationDocument"
            >更新</a-button
          >
        </div>
      </div>

      <div class="setting-item">
        <!-- 状态点+说明 -->
        <div class="left">
          <span :class="['status-dot', 'blue']"></span>
          <span class="main-text">切换密码</span>
          <span class="sub-text">保障登录密码安全使用</span>
        </div>

        <!-- 右侧公司名或时间 -->
        <div class="center"></div>

        <!-- 操作按钮 -->
        <div class="right">
          <a-button size="small" @click="clickUpdate">修改</a-button>
        </div>
      </div>
    </a-card>

    <a-modal
      :width="450"
      :footer="null"
      :visible="passwordVisible"
      :closable="true"
      :maskClosable="true"
      :zIndex="999"
      @cancel="closePasswordMoudle"
      destroyOnClose
    >
      <UpdatePassword
        @closePasswordMoudle="closePasswordMoudle"
      >
      </UpdatePassword>
    </a-modal>
  </div>
</template>

<script>
import { getTimeStatus } from "@/utils/util";
import { getCompanyDetail } from "@/api/company/Company.js";
import UpdatePassword from "./UpdatePassword";
export default {
  components: {
    UpdatePassword
  },
  data() {
    return {
      companyInfo: {
        companyName: undefined,
        unifySocialCreditCodes: undefined,
        operatingPeriodEndDate: undefined,
        authorizationExpirationDate: undefined,
      },
      spinning: true,
      passwordVisible: false,
    };
  },
  mounted() {
    getCompanyDetail()
      .then((res) => {
        if (res && res.code === "200") {
          const result = res.data;
          this.companyInfo.companyName = result.companyName;
          this.companyInfo.unifySocialCreditCodes =
            result.unifySocialCreditCodes;
          this.companyInfo.operatingPeriodEndDate =
            result.operatingPeriodEndDate;
          this.companyInfo.authorizationExpirationDate =
            result.authorizationExpirationDate;
          this.spinning = false;
        } else {
          this.spinning = false;
        }
      })
      .catch((err) => {
        this.spinning = false;
        console.error("接口调用异常：", err);
      });
  },
  methods: {
    verifyTimeStatus(timeInfo) {
      return getTimeStatus(timeInfo);
    },
    changeToBusinessLicense() {
      this.$emit("changeToBusinessLicense");
    },
    changeToAuthorizationDocument() {
      this.$emit("changeToAuthorizationDocument");
    },
    clickUpdate(){
      this.passwordVisible = true;
    },
    closePasswordMoudle() {
      this.passwordVisible = false;
    },
  },
};
</script>

<style scoped>
.company-info-page {
  padding: 8px;
}

.base-info {
  padding: 8px 16px;
  line-height: 32px;
  font-size: 14px;
}

.info-line .label {
  display: inline-block;
  width: 160px;
  font-weight: bold;
  color: #555;
}

.setting-item {
  display: flex;
  grid-template-columns: 180px 200px 1fr 50px;
  /* 左列、描述、中间值、按钮列 */
  align-items: center;
  padding: 14px 8px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}

.setting-item:last-child {
  border-bottom: none;
}

.left {
  width: 420px;
  display: flex;
  align-items: center;
  min-width: 700px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 16px;
}

.status-dot.blue {
  background-color: #1890ff;
}

.status-dot.gray {
  background-color: #d9d9d9;
}

.status-dot.red {
  background-color: red;
}

.status-dot.orange {
  background-color: orange;
}

.main-text {
  font-weight: 500;
  min-width: 250px;
  margin-right: 16px;
  white-space: nowrap;
}

.sub-text {
  color: #888;
  white-space: nowrap;
}

.center {
  flex: 1;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.right {
  width: 80px;
  text-align: right;
  flex-shrink: 0;
}
</style>